/* Prom Dollz — product carousels: arrows, swipe, auto-advance; loops so there's always a dress showing.
   Arrows and arrow keys are handled for the whole page, so a carousel that arrives after the page has loaded
   ("You may also love" on product pages is fetched afterwards) works too. A carousel whose dresses all fit on
   screen gets data-static, which hides its arrows.
   Loaded once per page from layout/theme.liquid (deferred), not by each section. Every [data-carousel] is set up
   once; sections added or changed in the theme editor are set up when Shopify fires shopify:section:load. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function step(track) { var s = track.children[0]; return s ? s.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; }
  function atEnd(track) { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
  function next(track) { if (atEnd(track)) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step(track), behavior: 'smooth' }); }
  function prev(track) { if (track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); else track.scrollBy({ left: -step(track), behavior: 'smooth' }); }

  function markStatic() {
    [].forEach.call(document.querySelectorAll('[data-carousel]'), function (car) {
      var track = car.querySelector('[data-car-track]');
      if (!track) return;
      if (track.scrollWidth <= track.clientWidth + 4) car.setAttribute('data-static', ''); else car.removeAttribute('data-static');
    });
  }

  var pending = false;
  function soon() { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; markStatic(); }); }

  // Product-page recommendations replace their own content once fetched.
  function watchRecs() {
    if (!('MutationObserver' in window)) return;
    [].forEach.call(document.querySelectorAll('[data-recommendations]'), function (el) {
      if (el._pdCarWatch) return; el._pdCarWatch = true;
      new MutationObserver(soon).observe(el, { childList: true, subtree: true });
    });
  }

  // Auto-advance, for carousels that ask for it.
  function setup(car) {
    if (car._pdCar) return; car._pdCar = true;
    var track = car.querySelector('[data-car-track]');
    if (!track || !track.children.length) return;

    var auto = car.getAttribute('data-autoplay') === 'true' && !reduce;
    var ms = (+car.getAttribute('data-interval') || 5) * 1000;
    var timer = null, paused = false, visible = false;
    function tick() { if (!paused && visible && !document.hidden) next(track); }
    function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(tick, ms); }
    car.pdRestart = restart;
    car.pdStop = function () { clearInterval(timer); timer = null; };
    if (auto) {
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { car.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { car.addEventListener(ev, function () { paused = false; }); });
      car.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(car);
      else visible = true;
      restart();
    }
  }

  function init() {
    watchRecs();
    markStatic();
    [].forEach.call(document.querySelectorAll('[data-carousel]'), setup);
  }

  // Page-wide handlers: registered once, even if an old copy of a section still includes this file.
  if (!window.pdCarouselHandlers) {
    window.pdCarouselHandlers = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-car-next], [data-car-prev]');
      var car = btn && btn.closest('[data-carousel]');
      var track = car && car.querySelector('[data-car-track]');
      if (!track) return;
      if (btn.hasAttribute('data-car-next')) next(track); else prev(track);
      if (car.pdRestart) car.pdRestart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var track = e.target.closest && e.target.closest('[data-car-track]');
      if (!track) return;
      e.preventDefault();
      if (e.key === 'ArrowRight') next(track); else prev(track);
      var car = track.closest('[data-carousel]');
      if (car && car.pdRestart) car.pdRestart();
    });
    window.addEventListener('resize', soon);
    // Theme editor: a section that is added or re-rendered comes in as new HTML, so set its carousels up;
    // one that is removed stops its auto-advance timer.
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      [].forEach.call(e.target.querySelectorAll('[data-carousel]'), function (car) { if (car.pdStop) car.pdStop(); });
    });
  }
  init();
})();
